import type { BoxProps } from '@chakra-ui/react'
import { Box, Flex, Grid, Stack } from '@chakra-ui/react'
import React from 'react'

import { Container } from '../../components/ui/Container'
import { VirtualScrollBar } from '../../layouts/components/VirtualScrollBar'

export interface PageWrapperProps {
  children?: React.ReactNode
  steps?: React.ReactNode
  header?: React.ReactNode
  contentHeader?: React.ReactNode
  sidebar?: React.ReactNode
  contentProps?: BoxProps
  mainProps?: BoxProps
}

export const LeftOffset = 250

export const PageWrapper = ({
  children,
  steps,
  header,
  contentHeader,
  sidebar,
  contentProps,
  mainProps,
}: PageWrapperProps) => {

  return (
    <Box>
      {steps && (
        <Box
          sx={{
            mb: { base: 0, md: 1 },
            zIndex: 'sticky',
          }}
        >
          {steps}
        </Box>
      )}

      {header && header}

      <Container>
        <Box sx={{ pb: 8, ...contentProps?.sx }}>

          {contentHeader &&
            <Grid
              sx={{
                position: 'relative',
                gridTemplateColumns: { md: sidebar ? `${LeftOffset}px 2rem minmax(0,1fr)` : '1fr' },
                gap: 0,
                pt: {
                  base: 4,
                  md: 0,
                },
              }}
            >
              <Box></Box>
              <Box></Box>
              <Stack gap={8}>
                {contentHeader}
              </Stack>
            </Grid>
          }

          <Grid
            sx={{
              position: 'relative',
              gridTemplateColumns: { md: sidebar ? `${LeftOffset}px 2rem minmax(0,1fr)` : '1fr' },
              gap: 0,
              pt: {
                base: 4,
                md: 0,
              },
            }}
          >
            {sidebar}

            {sidebar && <VirtualScrollBar />}

            <Box as="main" sx={{ minH: '50vh', alignContent: 'baseline', ...mainProps?.sx }}>
              {children}
            </Box>
          </Grid>
        </Box>
      </Container>

      <Flex id='fullWidthPlaceholder'>
      </Flex>
    </Box>
  )
}
